import React, { Component } from 'react';
import {numberParce} from '../../../../server/util'
class TotalAlacarteServed extends Component {
    constructor(props){
        super(props);
    }
    render() {
        const {data}=this.props
        return (
            <div className="mini-stat bg-3 clearfix rounded text-center">
                <span className="mini-stat-icon" style={{float:'none'}}><i className="fa fa-cutlery fg-3"></i></span>
                <div className="mini-stat-info">
                    Total A La Carte Served
                    {data.loading?<span className='loading'></span>:<span>{numberParce(((data.data||{}).ALaCarte||{}).totalCount)}</span>}                    
                </div>
            </div>
        );
    }
}
export default TotalAlacarteServed;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/totalAlacarteServed.jsx